import qs from 'qs';

const team = (server2) => {
    return ({
        messagePopup: messagePopup(server2),
    });
}

const messagePopup = (axios) => _ => {
    return axios.get('fosun-news?pagination[page]=1&pagination[pageSize]=5&sort=sort:desc', {
        headers: {

        },
        params: {
        }
    });
};

// const messagePopup = (axios) => _ => {
//     return axios.get('touguans', {
//         headers: {
//             Authorization: 'Bearer 1415f159506d9435ec9224f2d21f8b1312279f98be101a2a2975025ddf609d1a0b290a345bb7f2ff4b63cb5f3b706cef6dfe74b9b80c0273709f4eaf4c097c70d2aa7321317b910236a8fea85aa4690e3988e4b53e2ee88c1ed9d3fecc3f01624bc771851e91a5257ba3f1202488f6715a2d975f6a77f906f20bbbccc93f2b90'
//         },
//         params: {
//             pagination:{
//                 page: 1,
//                 pageSize: 5
//             }
//         }
//     });
// };

export default team;
